import * as React from 'react'
import { Table } from 'react-bootstrap'

import { UsersQueryResult } from '../../components/queries/UsersQuery'
import { UserRole } from '../../types'

export interface UsersTableProps {
  users: UsersQueryResult['users']
}

const UsersTable: React.SFC<UsersTableProps> = ({ users }) => {
  return (
    <Table striped={true} bordered={true} condensed={true} hover={true}>
      <thead>
        <tr>
          <th>Email</th>
          <th>Nickname</th>
          <th>Admin</th>
          <th>V systému</th>
        </tr>
      </thead>
      <tbody>
        {users.map(user => (
          <tr key={user.id}>
            <td>{user.email}</td>
            <td>{user.name}</td>
            <td>{user.roles.indexOf(UserRole.ADMIN) !== -1 ? 'Admin' : ''}</td>
            <td>{!user.isConfirmed && user.email != null ? 'Nepotvrzen' : ''}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default UsersTable



// WEBPACK FOOTER //
// ./src/screens/usersList/UsersTable.tsx